import { render } from "./input-switch.vue?vue&type=template&id=3fbab5fb&scoped=true"
import script from "./input-switch.vue?vue&type=script&lang=js"
export * from "./input-switch.vue?vue&type=script&lang=js"

import "./input-switch.vue?vue&type=style&index=0&id=3fbab5fb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbab5fb"]])

export default __exports__